export type Message = {
	name: string;
	email: string;
	message: string;
};

export const sendMessage = async (data: Message) => {
	const response = await fetch("/api/v1/contact", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	});

	if (!response.ok) {
		const errorBody = await response.text();
		throw new Error(
			`Failed to send message (Status ${response.status}): ${errorBody}`,
		);
	}

	return response.json();
};
